import { useEffect, useRef, useState } from "react";

const DEFAULT_PAGE_TITLE = "PlacedRisk Solutions";

function extractContentWrapperInner(html) {
  const wrapperStart = html.indexOf('<div class="content-wrapper"');
  if (wrapperStart === -1) return "";
  const startAfter = html.indexOf(">", wrapperStart);
  if (startAfter === -1) return "";

  // Stop right before footer include (so we don't duplicate Layout footer)
  const footerInclude = "<%-include ('partials/footer')%>";
  const endAt = html.indexOf(footerInclude, startAfter);
  if (endAt === -1) {
    // Fallback: stop at the first closing wrapper div if the include doesn't match exactly.
    const closeDiv = html.indexOf("</div>", startAfter);
    return closeDiv === -1 ? "" : html.slice(startAfter + 1, closeDiv);
  }

  return html.slice(startAfter + 1, endAt);
}

function extractTitle(html) {
  const match = html.match(/<title[^>]*>([\s\S]*?)<\/title>/i);
  if (!match) return "";
  return match[1].trim();
}

export default function LegacyEjsContent({
  templateUrl,
  normalizeRelativeImages = false,
  onLoaded,
  fallbackTitle = DEFAULT_PAGE_TITLE,
}) {
  const [innerHtml, setInnerHtml] = useState("");
  const wrapperRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(templateUrl);
        const text = await res.text();
        if (cancelled) return;

        const pageTitle = extractTitle(text);
        document.title = pageTitle || fallbackTitle;

        let extracted = extractContentWrapperInner(text);
        if (normalizeRelativeImages) {
          extracted = extracted.replace(/src="images\//g, 'src="/images/');
          extracted = extracted.replace(/href="images\//g, 'href="/images/');
        }
        setInnerHtml(extracted);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn("[legacy-ejs-content] failed:", templateUrl, e);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [templateUrl, normalizeRelativeImages, fallbackTitle]);

  useEffect(() => {
    if (!onLoaded) return;
    onLoaded(Boolean(innerHtml));
  }, [innerHtml, onLoaded]);

  useEffect(() => {
    if (!wrapperRef.current) return;

    // Ensure legacy hero/background sections render even before custom.js runs.
    const nodes = wrapperRef.current.querySelectorAll("[data-background]");
    nodes.forEach((node) => {
      const imagePath = node.getAttribute("data-background");
      if (!imagePath) return;
      node.style.backgroundImage = `url('${imagePath}')`;
      node.style.backgroundSize = node.style.backgroundSize || "cover";
      node.style.backgroundPosition = node.style.backgroundPosition || "center";
    });
  }, [innerHtml]);

  return (
    <div
      ref={wrapperRef}
      className="content-wrapper"
      dangerouslySetInnerHTML={{ __html: innerHtml }}
    />
  );
}

